import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import DiscoveryMapPage from '~/features/discovery/components/discovery/DiscoveryMap'

export const discoveryMapSchema = z.object({
  lat: z.coerce.number().default(35.6580),
  lng: z.coerce.number().default(139.7016),
  radius: z.coerce.number().default(3000),
  categoryId: z.coerce.number().optional(),
  shopId: z.coerce.number().int().positive().optional(),
  q: z.string().optional(),
  budget: z.coerce.number().optional(),
  nonSmoking: z.coerce.boolean().optional(),
  hasPrivateRoom: z.coerce.boolean().optional(),
  kidsAllowed: z.coerce.boolean().optional(),
  favoritesOnly: z.coerce.boolean().optional(),
  view: z.enum(['map', 'list']).optional(),
  snapshotId: z.string().optional(),
  onlyShowSelected: z.coerce.boolean().optional(),
})

import { seo } from '~/utils/seo'
import { getPageMeta } from '~/utils/seo-meta'

export const Route = createFileRoute('/{-$locale}/discovery')({
  validateSearch: discoveryMapSchema,
  head: ({ params }: any) => {
    const locale = params.locale
    const meta = getPageMeta('/discovery', locale)
    return seo({
      ...meta,
      pathname: '/discovery',
      locale,
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <DiscoveryMapPage />
}
